import { post } from "./http";
// import common from './constants';


// let basic = common.interfacePath.serverTestUrl;
// basic += '';

// let basic = "/ngOrder";

const monthApi = {
    listPageBuyer: params => { return post(`/planDemandMonthBuyer/listPageBuyer`, params); },
};

export default monthApi;